module.exports = __webpack_public_path__ + "img/takung.c8d9cf8b.jpg";